import * as yup from 'yup';

export const validationSchmaForCreateFeePayerWallet = {
  name: yup
    .string()
    .min(4, 'Too Short Name!')
    .max(30, 'Too Long Name!')
    .required('Name is required!'),
  description: yup.string().required('Description is required!')
};
